import React from 'react';

type ParagraphProps = {
    className?: string;
}

const Paragraph: React.FC<ParagraphProps> = ({ className, children }): JSX.Element => (
    <p className={['paragraph', className].join(' ')}>
        { children }
    </p>
);

export default Paragraph;
